// Shared by the React footer and the static HTML. Keep established Swedish labels.
export const FOOTER_LINK_GROUPS = [
  { title: "Upplägg", links: [
    { to: "/klassforsaljning", label: "Klassförsäljning" },
    { to: "/tjana-pengar-till-laget", label: "Lagförsäljning" },
    { to: "/tjana-pengar-till-foreningen", label: "Föreningsförsäljning" },
  ] },
  { title: "Om tjänsten", links: [
    { to: "/tjana-pengar-till-studenten", label: "Guide: Tjäna pengar till studenten" },
    { to: "/salja-med-klassen", label: "Guide: Sälja med klassen" },
    { to: "/tjana-pengar-till-klassresan", label: "Guide: Tjäna pengar till klassresan" },
    { to: "/sa-fungerar-salespartner", label: "Så fungerar SalesPartner" },
    { to: "/provision-och-fortjanst", label: "Provision och förtjänst" },
    { to: "/vanliga-fragor", label: "Frågor och svar" },
    { to: "/products", label: "Produkter" },
    { to: "/contact", label: "Kontakt" },
  ] },
  { title: "Villkor", links: [
    { to: "/kopvillkor", label: "Köpvillkor" },
    { to: "/integritetspolicy", label: "Integritetspolicy" },
    { to: "/cookiepolicy", label: "Cookiepolicy" },
    { to: "/retur-och-angerratt", label: "Retur & ångerrätt" },
    { to: "/leveransvillkor", label: "Leveransvillkor" },
    { to: "/gruppledaravtal", label: "Gruppledaravtal" },
    { to: "/utbetalningsvillkor", label: "Utbetalningsvillkor" },
  ] },
];
